<div class="relative mt-5" *ngIf="displayFounderBox">
  <div
    class="text-black text-sm font-semibold leading-snug absolute top-[-8px] left-[10px] px-[10px] bg-white"
  >
    Founders
  </div>
  <div class="w-full border-[2px] border-solid border-[#14192D] rounded-[4px] p-3 flex flex-col justify-start items-center">
    <!-- Creator Row -->
    <div class="flex items-center justify-between gap-3 mt-3 w-full">
      <div class="flex items-center gap-3 min-w-0 flex-1">
        <div class="w-[50px] h-[50px] shrink-0">
          <img
            class="w-full h-full rounded-full object-cover"
            [src]="founderData.icon || founderData.nft || 'https://www.gravatar.com/avatar/?d=mp'"
            alt="{{ founderData.nickname }}'s profile"
          />
        </div>
        <div class="flex flex-col min-w-0">
          <span class="text-sm font-semibold text-gray-800 truncate">
            {{ '@' + founderData.nickname }}
          </span>
          <span class="text-[12px] leading-[20px] font-normal text-[#565761] truncate">
            {{ founderData.firstName }} {{ founderData.lastName }}
          </span>
          <!-- Show status only if isMine is true and status is not 'accepted' -->
          <div *ngIf="isMine && (founderData.status || 'invited').toLowerCase() !== 'accepted'" class="flex flex-row items-center justify-start gap-1">
            <ark-lib-icon-name
              [name]="(founderData.status || 'invited').toLowerCase() === 'invited' ? 'contact' : 'contact-red'"
            ></ark-lib-icon-name>
            <span
              class="text-[12px] leading-[20px] font-normal truncate"
              [ngClass]="(founderData.status || 'invited').toLowerCase() === 'invited' ? 'text-[#565761]' : 'text-[#C83764]'"
            >
              {{ (founderData.status || 'Invited') | firstLetterUppercase }}
            </span>
          </div>
        </div>
      </div>
      <div class="flex items-center gap-2 w-[120px] justify-end">
        <ark-input
          label="%"
          size="small"
          [value]="founderPercentage | number:'1.0-2'"
          [readonly]="true"
          [hideIcons]="true"
          class="w-[50px] !min-w-0 !max-w-[50px] h-[30px] !min-h-[30px]"
        ></ark-input>
      </div>
    </div>

    <!-- Added Founders List (no status shown) -->
    <div *ngIf="allFounders.length > 0" class="mt-3 w-full">
      <div *ngFor="let founder of allFounders" class="w-full">
        <div
          class="flex items-center justify-between border-t border-gray-200 pt-2 mt-2 w-full"
        >
          <div class="flex items-center gap-3 min-w-0 flex-1">
            <div class="w-[50px] h-[50px] shrink-0">
              <img
                class="w-full h-full rounded-full object-cover"
                [src]="founder?.icon || founder?.nft || 'https://www.gravatar.com/avatar/?d=mp'"
                alt="{{ founder?.nickname }}'s profile"
              />
            </div>
            <div class="flex flex-col min-w-0">
              <span class="text-sm font-semibold text-gray-800 truncate">
                {{ '@' + founder?.nickname }}
              </span>
              <div *ngIf="isMine && (founder?.status || 'invited').toLowerCase() !== 'accepted'" class="flex flex-row items-center justify-start gap-1">
                <ark-lib-icon-name
                  [name]="(founder?.status || 'invited').toLowerCase() === 'invited' ? 'contact' : 'contact-red'"
                ></ark-lib-icon-name>
                <span
                  class="text-[12px] leading-[20px] font-normal truncate"
                  [ngClass]="(founder?.status || 'invited').toLowerCase() === 'invited' ? 'text-[#565761]' : 'text-[#C83764]'"
                >
                  {{ (founder?.status || 'Invited') | firstLetterUppercase }}
                </span>
              </div>
            </div>
          </div>

          <div class="flex items-center gap-2 w-[120px] justify-end shrink-0">
            <ark-input
              label="%"
              size="small"
              [value]="founder.percentage | number:'1.0-2'"
              [hideIcons]="true"
              [readonly]="true"
              class="w-[50px] !min-w-0 !max-w-[50px] h-[30px] !min-h-[30px]"
            ></ark-input>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
